/* DSD Identity Authority / FirebaseAuth bridge – p11dz85
 * Exposes one canonical auth readiness object for diagnostics and social UI.
 * It does not create a second login system; Shopify customer state remains the account source.
 */
(function(){
  if (window.DSDIdentityAuthority && window.DSDIdentityAuthority.version) return;
  var VERSION='p11dz85-identity-authority-bridge-v1';
  var customer = window.DSDShopifyCustomer || null;
  var authenticated = !!(customer && customer.authenticated === true);
  var profileKey = customer && (customer.profileKey || customer.handle) ? String(customer.profileKey || customer.handle).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') : 'guest';
  var displayName = customer && customer.displayName ? String(customer.displayName) : 'DSD member';
  var state = {
    ready:true,
    provider:'shopify-customer-bridge',
    isAuthenticated: authenticated,
    uid: null,
    profileKey: profileKey,
    displayName: displayName,
    customer: customer ? {
      authenticated: authenticated,
      profileKey: customer.profileKey || '',
      handle: customer.handle || '',
      displayName: displayName,
      isFounder: customer.isFounder === true,
      isAdmin: customer.isAdmin === true,
      isModerator: customer.isModerator === true,
      platformRole: customer.platformRole || null,
      membership: customer.membership || null,
      storeScopedIdentity: customer.storeScopedIdentity === true,
      privateIdentityBridgeRequired: true
    } : null,
    version: VERSION
  };
  function claim(surface, owner, meta){ try{ if(window.DSDRegistry&&window.DSDRegistry.claim) window.DSDRegistry.claim(surface,owner,meta||{}); }catch(e){} }
  function getState(){ return Object.assign({}, state); }
  function requireLogin(){ return !!state.isAuthenticated; }
  window.DSDAuthState = state;
  window.DSDFirebaseAuth = { version: VERSION, ready:true, currentUser: state.isAuthenticated ? { uid: state.uid, displayName: state.displayName, profileKey: state.profileKey } : null, getState:getState, requireLogin:requireLogin };
  window.DSDIdentityAuthority = {
    version: VERSION,
    ready: true,
    authenticated: state.isAuthenticated,
    profileKey: state.profileKey,
    state: state,
    getState:getState,
    requireLogin:requireLogin,
    currentUser: window.DSDFirebaseAuth.currentUser
  };
  claim('firebase-auth:shopify-customer-bridge','FirebaseAuth',{ version:VERSION, ready:true, authenticated:state.isAuthenticated, provider:state.provider });
  claim('identity-authority:ready','DSDIdentityAuthority',{ version:VERSION, profileKey:state.profileKey, authenticated:state.isAuthenticated });
})();
